<template>
<main>
<div style="height:900px;">

  <div class="demo-image__placeholder">
  <div class="block">
    <el-image :src="src"></el-image>
  </div>
  </div>

<el-card>
  
    <el-button size="mini"
           type="primary"
           icon="el-icon-s-promotion"
           style="position: absolute; left: 1%" @click="handleToLogin()" plain><el-text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ $t('contact.backToLoginPage', { msg: 'contact.backToLoginPage' }) }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-text></el-button>
 
      <h1 class="title">{{ $t('contact.contact', { msg: 'contact.contact' }) }}</h1>
      <br>
      <br>
      <p class="mt20 cn_line">
        &nbsp;&nbsp;&nbsp; {{ $t('contact.info1', { msg: 'contact.info1' }) }}
      </p>
      <br>
      <br>
      <br>
   
      
      <!-- <div class="mt20 cn_line fl" style="width:33%;height:150px;float: left;">
        <span
          style="line-height:34px;color:#0aaae1;font-size:24px;"
          >{{ $t('contact.workTime', { msg: 'contact.workTime' }) }}</span
        ><br />
       {{ $t('contact.tel', { msg: 'contact.tel' }) }}<br />
        <span style="font-size:12px;color:#888;"
          >{{ $t('contact.telTime', { msg: 'contact.telTime' }) }}</span
        ><br />
        {{ $t('contact.emailCallBack', { msg: 'contact.emailCallBack' }) }}
      </div>
 
      <div class="mt20 cn_line fl" style="width:33%;height:150px;float: left">
        <span
          style="line-height:34px;color:#0aaae1;font-size:24px;"
          >{{ $t('contact.bCororptation', { msg: 'contact.bCorportation' }) }}</span
        ><br />
        {{ $t('contact.charger', { msg: 'contact.charger' }) }}<br />
        {{ $t('contact.chargerTel', { msg: 'contact.chargerTel' }) }}<br />
        {{ $t('contact.chargerEmail', { msg: 'contact.chargerEmail' }) }}
      </div>
   
      <div class="mt20 cn_line fl" style="width:33%;height:150px; float: left;">
        <span
          style="line-height:34px;color:#0aaae1;font-size:24px;"
          >{{ $t('contact.service', { msg: 'contact.service' }) }}</span
        ><br />
        {{ $t('contact.charger2', { msg: 'contact.charger2' }) }}<br />
        {{ $t('contact.charger2Tel', { msg: 'contact.charger2Tel' }) }}<br />
        {{ $t('contact.charger2Email', { msg: 'contact.charger2Email' }) }}
      </div> -->
    <div class="block">
    <span class="demonstration"></span>
    <el-image :src="contactpng"></el-image>
    </div>
      
 



  <!-- 联系会话 -->
 
  <div class="demo-imager-foot">
  <div class="block">
    <span class="demonstration"></span>
    <el-image :src="footer"></el-image>
  </div>
  <div class="block">
    <span class="demonstration"></span>
    <el-image :src="chat">  
    </el-image>
   <span><div><el-link >{{$t('contact.pro', { msg: 'contact.pro' })}}</el-link></div></span>
  </div>
</div>
</el-card>

<div class="demo-image_heng">
  <div class="block">
    <el-image :src="heng"></el-image>
  </div>
</div>

</div>
</main>
</template>

<script>
export default {
    data() {
      return {
        src: 'https://srb-data.oss-cn-beijing.aliyuncs.com/IssueFile/2024/04/16/call.png',
        footer:'https://srb-data.oss-cn-beijing.aliyuncs.com/IssueFile/2024/04/15/foot_view.png',
        chat:'https://srb-data.oss-cn-beijing.aliyuncs.com/IssueFile/2024/04/15/vxgzh.png',
        heng:'https://srb-data.oss-cn-beijing.aliyuncs.com/IssueFile/2024/04/16/heng.png',
        contactpng:'https://srb-data.oss-cn-beijing.aliyuncs.com/IssueFile/2024/04/16/contact.png',
      }
    },
    created() {
  },
  methods:{
    //跳转到登录页
    handleToLogin(){
        this.$router.push({
      path:'/login',
     }); 
    },



  }
    
}
</script>

<style>
.box-card {
    width: 480px;
  }
  .demo-imager-foot {
      margin: 0 auto;
      display: flex; /*就是可以把多个图片放在一行展示，发不下的话再换行*/
    }
  .issue-space{
    text-align: left;
  }
  .demo-image_heng{
    width: 100%;
  }
</style>